import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { PasswordChangeInterceptor } from './core/interceptors/password-change.interceptor';

import {
  CommonModule,
  HashLocationStrategy,
  LocationStrategy,
} from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    SharedModule,
    HttpClientModule,
    CommonModule,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    // B-FORCE-PASSWORD (Atenza parity) — catches the server's 423
    // PASSWORD_CHANGE_REQUIRED and sends the user to the set-password screen. Needed because the
    // auth guard reads the CACHED user: someone already signed in before the rollout has a cached
    // record with no flag, so the guard stays quiet while every call is correctly refused.
    { provide: HTTP_INTERCEPTORS, useClass: PasswordChangeInterceptor, multi: true },
  ],

  bootstrap: [AppComponent],
})

export class AppModule { }
